var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('div',{staticClass:"shift-wrapper"},[_c('div',{staticClass:"list-block"},[_c('Table',{attrs:{"clickHighlight":false,"columns":_vm.columns,"rows":_vm.rows,"filter":{},"loading-instance":_vm.loadingInstance,"set-loading-instance":_vm.setLoadingInstance,"pagination":false,"tableName":"shiftPlansTable"}})],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }